import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { AttendanceRosterStudentRow } from './AttendanceRosterStudentRow';
import { SFEntityID } from "../utils/types";

class AttendanceRoster extends React.Component {

  render() {
    return (
      <Table aria-hidden={true} style={{visibility: 'hidden'}}>
        <Table.Body>
          {
            this.props.students.map((record, index) =>
              <AttendanceRosterStudentRow
                key={index}
                name={record.name}
                id={record.id}
                uuid={record.uuid}
                phone={record.phone}
                email={record.email}
                hasPhoto={record.hasPhoto}
              />
            )
          }
        </Table.Body>
      </Table>
    );
  }

}

AttendanceRoster.propTypes = {
  students: PropTypes.arrayOf(PropTypes.shape({
    id: SFEntityID.isRequired,
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    phone: PropTypes.string,
    email: PropTypes.string,
    hasPhoto: PropTypes.bool
  }).isRequired)
}

export default AttendanceRoster;
